/**
 * Resolve order-queue details id from React Router location.state.
 * New flow uses `queue_details_id`; legacy navigation used `customOrderId`.
 */
export function resolveQueueDetailsId(state) {
  if (!state) return null;
  const qd = state.queue_details_id;
  if (qd !== undefined && qd !== null && qd !== "" && qd !== 0 && qd !== "0") {
    return qd;
  }
  // Custom-order / repairing table → Sales already carries line rows.
  // Do not treat that `customOrderId` as a queue details id.
  if (
    Array.isArray(state.customOrderTable) &&
    state.customOrderTable.length > 0
  ) {
    return null;
  }
  const legacy = state.customOrderId;
  if (
    legacy !== undefined &&
    legacy !== null &&
    legacy !== "" &&
    legacy !== 0 &&
    legacy !== "0"
  ) {
    return legacy;
  }
  return null;
}

/** Normalize show/list order-queue API payloads into an array of orders. */
export function extractOrderQueueOrders(response) {
  const d = response?.data;
  if (!d) return [];
  if (Array.isArray(d)) return d;
  if (Array.isArray(d.items)) return d.items;
  if (Array.isArray(d.data)) return d.data;
  if (Array.isArray(d.orders)) return d.orders;
  if (Array.isArray(d.records)) return d.records;
  // Single order object from type "show" + id
  if (d.id != null || Array.isArray(d.products)) return [d];
  if (d.order && (d.order.id != null || Array.isArray(d.order.products))) {
    return [d.order];
  }
  return [];
}

export function findOrderQueueInResponse(response, orderId) {
  const orders = extractOrderQueueOrders(response);
  return (
    orders.find((order) => String(order.id) === String(orderId)) || null
  );
}

export function buildOrderQueueNavigationState(order, pageSource) {
  const base = {
    queue_details_id: order.id,
    customerUserId: order.customer_user_id ?? order.user_id ?? null,
    area: order.area ?? undefined,
    // Snapshot so Sales/CO/Repair can load without re-fetching the full queue list
    customOrderData: order,
  };
  if (pageSource === "COPRO") {
    return { ...base, customOrderId: 0 };
  }
  return base;
}
